import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import FDIService from './service'

export const getFdiData = createAsyncThunk(
  'companyAnalysis/industryOverview/macroeconomics/getFdiData',
  async (params, { rejectWithValue }) => {
    try {
      const res = await FDIService.getFdiData(params)

      return res.success ? res.data : rejectWithValue({ isLoading: false })
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)
